export enum FeatureFlag {
  MemoryMonitor = "memory-monitor",
  SignupEnabled = "signup-enabled",
  CaseChatEnabled = "case-chat-enabled",
}
